import { SalonStatus } from '../models/salon-status';

export class SalonStatusUtils {
  public static canBook(status: SalonStatus | undefined): boolean {
    return status === SalonStatus.SUBSCRIBED || status === SalonStatus.SUBSCRIPTION_CANCELLED || status === SalonStatus.TRIAL;
  }

  public static canCancelSubscription(status: SalonStatus | undefined): boolean {
    return status === SalonStatus.SUBSCRIBED;
  }

  public static canClaimPrettyUrl(status: SalonStatus | undefined): boolean {
    // FREE-SALON
    return status !== SalonStatus.SUSPENDED;
  }

  public static hasActiveSubscription(status: SalonStatus | undefined): boolean {
    return status === SalonStatus.SUBSCRIBED;
  }

  public static hasNoActiveSubscription(status: SalonStatus | undefined): boolean {
    return (
      status === SalonStatus.TRIAL ||
      status === SalonStatus.TRIAL_EXPIRED ||
      status === SalonStatus.SUBSCRIPTION_EXPIRED ||
      status === SalonStatus.SUBSCRIPTION_CANCELLED ||
      status === SalonStatus.SUSPENDED
    );
  }

  public static hasOrHadSubscription(status: SalonStatus | undefined): boolean {
    return (
      status === SalonStatus.SUBSCRIBED || status === SalonStatus.SUBSCRIPTION_EXPIRED || status === SalonStatus.SUBSCRIPTION_CANCELLED
    );
  }

  public static hasTrialOrSubscriptionExpired(status: SalonStatus | undefined): boolean {
    return status === SalonStatus.TRIAL_EXPIRED || status === SalonStatus.SUBSCRIPTION_EXPIRED;
  }
}
